// Build-time feature flags. Vite inlines `import.meta.env.*` at build, so these
// are plain constants — side-effect-free (safe to import from ConsentBackdrop,
// which may import only React + side-effect-free constants).

/**
 * RFC-0934 P1 templates gallery. Default OFF so the public `/templates` route,
 * the landing "Templates" nav link, and its consent-backdrop mirror stay dark in
 * prod until templates are curated. Flip `VITE_ENABLE_TEMPLATES_GALLERY=true`
 * (build/env) to launch — same mechanism as `VITE_MAINTENANCE_BANNER_ENABLED`.
 */
export const TEMPLATES_GALLERY_ENABLED =
  import.meta.env.VITE_ENABLE_TEMPLATES_GALLERY === 'true'

/**
 * RFC-0945 audio-split (vocals/background). Default OFF. Gates both the Video
 * Editor "Split vocals and background" extraction option and the Speech
 * Transformer "Isolate vocals before analysis" toggle. Flip
 * `VITE_FEATURE_AUDIO_SPLIT=true` (build/env) to surface them.
 */
export const AUDIO_SPLIT_ENABLED = import.meta.env.VITE_FEATURE_AUDIO_SPLIT === 'true'

/**
 * RFC-0986 unified audio editor. Default OFF. When flipped on it surfaces the
 * new flag-gated "Audio" (lanes) tab on the video_generator node (Phase 2) and
 * enables the backend lane read-model + lane render (Phase 1). Flip
 * `VITE_FEATURE_UNIFIED_AUDIO_EDITOR=true` (build/env) to surface it. No
 * consumer yet in Phase 1 (backend-only).
 */
export const UNIFIED_AUDIO_EDITOR_ENABLED =
  import.meta.env.VITE_FEATURE_UNIFIED_AUDIO_EDITOR === 'true'

/**
 * v1 upfront project-planning modal. Default OFF (ship dark). Gates the landing
 * hero "Settings" button that opens the "Your project plan" modal before Create
 * (story fields + video settings captured up front, sent in the createProject
 * payload). Flip `VITE_FEATURE_UPFRONT_PROJECT_PLAN=true` (build/env) to surface
 * it. Backend fields are additive/backward-compatible, so this flips on/off with
 * no backend redeploy. Landing-only in v1 (dashboard create is deferred).
 */
export const UPFRONT_PROJECT_PLAN_ENABLED =
  import.meta.env.VITE_FEATURE_UPFRONT_PROJECT_PLAN === 'true'
